export default "/images/Privaposts-Bank-icon.png?ad104238bbd739a46770acd031458d74";